module.exports = __webpack_public_path__ + "img/envelope.79afe828.svg";